import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const PaymentInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Payment Information">
            <DataRow
                label="Base Monthly Payment"
                value={pdfData.base_payment.toDollarFormat()}
            />
            <DataRow
                label="Total Monthly Payment"
                value={pdfData.monthly_payment.toDollarFormat()}
                isTotal
                variant="blue"
                isLast
            />
        </Panel>
    )
}
